import { Form } from 'reactstrap';
import PropTypes from 'prop-types';
import ModalClickable from '../../../layouts/modals/ModalClickable';
import useUsuarioForm from './hooks/useUsuarioForm';
import DatosPersonalesForm from './DatosPersonalesForm';
import DatosEscolaresForm from './DatosEscolaresForm';
import DatosTutoresForm from './DatosTutoresForm';
import FormActions from './FormActions';

const FormularioNuevoUsuario = ({ empresaId, mode }) => {
  const {
    formik,
    age,
    modal,
    text,
    stay,
    newId,
    idCedesca,
    idCntec,
    yearsApi,
    academicFormation,
    formationCenter,
    country,
    province,
    poblationFiltered,
    poblationBirthFiltered,
    cpFiltered,
    studiesList,
    studiesList2,
    fidelitationlist,
    sitLaboralList,
    lastStudiesList,
    parentescoList,
    document,
    rowRef1,
    rowRef2,
    rowRef3,
    rowRef4,
    setModal,
    handleFechaTitulos,
    handleFechaNacimiento,
    handleBirthProvinceChange,
    handleProvinceChange,
    handlePoblationChange,
  } = useUsuarioForm(empresaId, mode);

  return (
    <>
      {modal ? (
        <ModalClickable
          header={text}
          color="primary"
          url={stay ? '' : `/alumnos/${empresaId}/${newId}/detalles`}
          function={setModal}
        />
      ) : (
        ''
      )}
      <Form
        onSubmit={(e) => {
          e.preventDefault();
          formik.handleSubmit();
        }}
      >
        <DatosPersonalesForm
          formik={formik}
          age={age}
          document={document}
          country={country}
          province={province}
          poblationFiltered={poblationFiltered}
          poblationBirthFiltered={poblationBirthFiltered}
          cpFiltered={cpFiltered}
          formationCenter={formationCenter}
          fidelitationlist={fidelitationlist}
          idCedesca={idCedesca}
          idCntec={idCntec}
          rowRef1={rowRef1}
          handleFechaNacimiento={handleFechaNacimiento}
          handleProvinceChange={handleProvinceChange}
          handlePoblationChange={handlePoblationChange}
          handleBirthProvinceChange={handleBirthProvinceChange}
        />
        <DatosEscolaresForm
          formik={formik}
          yearsApi={yearsApi}
          academicFormation={academicFormation}
          formationCenter={formationCenter}
          studiesList={studiesList}
          studiesList2={studiesList2}
          lastStudiesList={lastStudiesList}
          sitLaboralList={sitLaboralList}
          empresaId={empresaId}
          idCedesca={idCedesca}
          idCntec={idCntec}
          rowRef2={rowRef2}
          handleFechaTitulos={handleFechaTitulos}
        />
        <DatosTutoresForm
          formik={formik}
          age={age}
          document={document}
          parentescoList={parentescoList}
          rowRef3={rowRef3}
          rowRef4={rowRef4}
        />
        <FormActions />
      </Form>
    </>
  );
};

FormularioNuevoUsuario.propTypes = {
  empresaId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  mode: PropTypes.string,
};

export default FormularioNuevoUsuario;
